import { render, staticRenderFns } from "./LoginVerify.vue?vue&type=template&id=56ba4dc8&"
import script from "./LoginVerify.vue?vue&type=script&lang=js&"
export * from "./LoginVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports